import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, catchError, Observable, pipe, throwError, switchMap, filter, take } from 'rxjs';
import { Router } from '@angular/router';
import { TokenStorageService } from 'src/app/authentication/storage/token-storage.service';
import { TokenService } from 'src/app/authentication/services/token.service';

const TOKEN_HEADER_KEY = 'Authorization';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {

  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(
    private tokenStorageService: TokenStorageService,
    private tokenService : TokenService,
    private router: Router){

  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>  {
  
    const token = this.tokenStorageService.getToken();

    if (token != null) {
      request = request.clone({ headers: request.headers.set(TOKEN_HEADER_KEY, 'Bearer ' + token) });
    }
    else {
      // uncommet this!! Only for developing
      this.router.navigate(['/auth']);
    }
    return next.handle(request);
  }
}
